<!-- Built with Common Launchpad 4.0.2 -->

<template>
  <div class="control-checkbox-list">
      <div class="control-checkbox-list__trigger"
           :class="{ open: isOpen }"
           @click="toggleDropdown">
          <span>{{ parent.label }}</span> <span v-if="count > 0">{{ countEle }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.724338 8.58328C0.291757 8.1507 0.291757 7.44935 0.724338 7.01677L6.81665 0.924459C7.24923 0.491878 7.95058 0.491878 8.38316 0.924459L14.4755 7.01677C14.908 7.44935 14.908 8.1507 14.4755 8.58328C14.0429 9.01586 13.3415 9.01586 12.909 8.58328L7.5999 3.27423L2.29085 8.58328C1.85827 9.01586 1.15692 9.01586 0.724338 8.58328Z" fill="currentColor" />
          </svg>
      </div>
    <div v-if="isOpen" class="control-checkbox-list__menu">
      <div class="control-checkbox-list__content">
        <div v-for="(checkbox, index) in checkboxes"
             class="control-checkbox-list__checkbox">
          <label class="control-checkbox-list__item">
              <span v-html="formatTrademark(checkbox.label)"/>
            
            <input type="checkbox"
                   checked="checked"
                   v-model="selectedValues"
                   :value="checkbox.value"
                   :name="checkbox.label"
                   @change="updateFilters(checkbox, $event)">
            <span class="control-checkbox-list__checkmark">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none">
                    <path d="M12.2043 0.326893L5.21005 7.53508L2.18216 4.407C1.84194 4.10715 1.37688 4.00515 0.947239 4.13584C0.517597 4.26653 0.18134 4.61215 0.0542952 5.05431C-0.0727613 5.49623 0.0264047 5.97458 0.317922 6.32452L4.28454 10.4045C4.53224 10.6579 4.86735 10.8 5.21664 10.8C5.56594 10.8 5.90105 10.6579 6.14874 10.4045L14.082 2.24453C14.3735 1.89459 14.4729 1.41623 14.3456 0.974313C14.2186 0.532164 13.8825 0.186523 13.4527 0.0558469C13.023 -0.0748412 12.5582 0.0271601 12.2177 0.32701L12.2043 0.326893Z" fill="currentColor" /></svg>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ControlCheckbox from './control-checkbox.vue';
import windowWidthMixin from '../../mixins/window-width';
export default {
  props: ['controls', 'parent', 'specification'],
  mixins: [windowWidthMixin],
  data: function () {
    return {
      isOpen: false,
      checkboxes: this.controls,
      selectedFilters: [],
      selectedValues: [],
      count: 0,
    };
  },
  components: {
    ControlCheckbox
  },
  watch: {
    windowWidth() {
      this.isOpen = false
    }
  },
  updated: function () {
    if (this.selectedValues.length === 0) {
      this.selectedValues = [
        '999'
      ];
    }
  },
  computed: {
      countEle() {
        return this.selectedValues.filter(el => el !== '999').length;
      }
  },
    methods: {
    ...mapMutations('listing', { addTagFilter: 'addNewTagFilter' }),
    ...mapMutations('listing', { clearTagBySpecification: 'clearTagBySpecification' }),
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    formatTrademark(text) {
      if (!text) return '';
      return text.replace(/(®|&reg;|&#174;|™|&#153;|©|&#169;)/g, '<sup>$1</sup>');
    },
    updateFilters(checkbox, $event) {
      // Check if value is 'All' (999)
      if(this.selectedValues.includes($event.target.value)) {
          this.count++;
        } else {
            this.count--;
        }

      if ($event.target.value === '999') {
        //Clear all count and tags.
        this.selectedValues = ['999'];
        this.clearTagBySpecification(this.specification);
        this.count = 0;
      } else {
        // Remove previously selected 'All' (999)
        this.selectedValues = this.selectedValues.filter(item => item !== '999');
        this.addTagFilter({label: this.applySup($event.target.name), value: $event.target.value, spec: this.specification})
      }       

      const pageTitle = window.location.pathname.split('/')[1];
      const gEvent = {
        'event': 'filter_selection',
        'filter_parameters': {
          'filter_type': this.specification,
          'filter_value': $event.target.value,
          'filter_page_type': pageTitle.substring(0,1).toUpperCase() + pageTitle.substring(1) 
        }
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(gEvent);

      this.$emit('updatecheckboxfilter', this.selectedValues);        
    },
    updateCheckboxFilter() {
      this.$emit('updatecheckboxfilter');
    },
    dataAttr(checkbox) {
      // Add GTM data attribute for recipe filters
      if (this.specification === 'Topic') {
        if (checkbox.value === '999') {
          return { 'data-recipe-filter': checkbox.label };

        } else {
          return { 'data-recipe-filter': checkbox.value };
        }
      } else {
        return {};
      }
    },
    handleClickOutside(event) {
      if (this.isSmallScreen) return;

      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
       applySup(input) {
          const tagReplacements = {
            '(®)': '<sup>$1</sup>',
            '(&reg;)': '<sup>$1</sup>',
            '(™)': '<sup>$1</sup>',
            '(©)': '<sup>$1</sup>',
            '(%)': '<sup>$1</sup>',
            // Add more patterns and replacements as needed
          };

          let result = input; // Create a mutable copy of the input

          for (const pattern in tagReplacements) {
            if (tagReplacements.hasOwnProperty(pattern)) {
              const replacement = tagReplacements[pattern];
              const regex = new RegExp(pattern, 'g'); // 'g' flag for global replacement
              result = result.replace(regex, replacement);
            }
          }

  return result;
    },
  },
  mounted() {
    let initialData = this.$store.state.listing.specification[this.specification];
    if (typeof(intialData) !== undefined && initialData !== null && initialData !== '') {
      this.selectedValues = initialData.split(',');     

      // Set Initial Selected Values Based On Specification
      this.selectedValues.forEach((item) => {       
        const checkbox = this.checkboxes.find(cb => cb.value === item);
        if(checkbox == null) return;
        this.addTagFilter({label: this.applySup(checkbox.label), value: item, spec: this.specification})
      });

      if (this.selectedValues.length != null) this.count = this.selectedValues.length; 
    } else {
      this.selectedValues = ['999'];
    }

    // clear current input on reset
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'listing/resetSpecification') {
        this.selectedValues = [];
        this.count = 0;
      }
        if (mutation.type === 'listing/removeTagFilter') {
            this.selectedValues = this.selectedValues.filter(item => item !== decodeURIComponent(state.listing.specification[this.specification])) || ['999'];
            if (this.count > 0) this.count--;     
        }

       if (mutation.type === 'listing/updateSpecification') {  
            this.selectedValues = state.listing.selectedFilters
               .filter(item => item.spec === this.specification)
               .map(item => item.value);
       }
    });

    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>